import type { FunctionComponent } from 'react';
import { useClient } from '../../../api';
import { useTotalSelectedBankableAssets } from '../../exporter/scenarios/hooks';
import { ChartLegendItem } from './ChartLegendItem';

interface IProps {
    chart?: Highcharts.Chart;
    legendName?: string;
    legendColor?: string;
    legendType?: string;
    label?: string;
    value: string;
    twr?: number;
}

export const MonteCarloChartLegendItem: FunctionComponent<IProps> = ({ chart, legendName, legendColor, legendType, label, value, twr }) => {
    const { data: client } = useClient();
    const totalSelectedBankableAssets = useTotalSelectedBankableAssets();

    return (
        <div className="monte-chart-legend-item">
            <div className="monte-chart-legend-item__label">{label}</div>
            <h5 className="monte-chart-legend-item__value">
                {client?.currency ?? ''} {value}
                {twr != null ? ` / ${totalSelectedBankableAssets <= 0 ? '-' : twr.toFixed(2)}%` : ''}
            </h5>
            {legendName && <ChartLegendItem chart={chart} name={legendName} color={legendColor} type={legendType} />}
        </div>
    );
};
